import {UserAddress} from "../../types/Delivery.interface.ts";
import {getOrderDeliveryType, OrderDeliveryType} from "../getOrderDeliveryType.ts";

const DEFAULT_TRANSPORT_COMPANY_BRANCH_NAME: string = 'Доставка транспортной компанией';

export const formatBranchName = (prefix: string, userAddress: UserAddress): string => {
    return getOrderDeliveryType(userAddress) === OrderDeliveryType.transport_company ? DEFAULT_TRANSPORT_COMPANY_BRANCH_NAME : prefix + userAddress.point.address;
}

export function formatBranchNameInProductCard(prefix: string, userAddress: UserAddress): string {
    return getOrderDeliveryType(userAddress) === OrderDeliveryType.transport_company ? 'Отгрузка со склада г. Владивосток' : prefix + userAddress.point.address;
}

export function formatBranchOfferDate(date: string, userAddress: UserAddress): string {
    return userAddress.point.townId !== userAddress.townId ? 'Отгрузка со склада ' + userAddress.point.address + ' ' + date + ' при заказе сейчас' : '';
}